function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var MainTemplate = require('./main.template');
var _require = require('./draft-store'),
  loadDraft = _require.loadDraft,
  saveDraft = _require.saveDraft;
var _require2 = require('./validator'),
  validateSource = _require2.validateSource;
var MAX_IMPORT_BYTES = 2 * 1024 * 1024;
var NFTStudioMain = /*#__PURE__*/function () {
  function NFTStudioMain(app, mod) {
    _classCallCheck(this, NFTStudioMain);
    this.app = app;
    this.mod = mod;
    this.editor = null;
    this.validationTimer = null;
    this.previewVisible = false;
    this.sidebarExpanded = true;
    this.type = 'js';
    this.title = 'Untitled NFT';
    this.source = '';
    this.isDirty = false;
  }
  return _createClass(NFTStudioMain, [{
    key: "render",
    value: function render() {
      var container = document.querySelector('.saito-container');
      if (!container) {
        return;
      }
      this.teardown();
      document.body.classList.add('nftstudio-page');
      if (container.querySelector('.nftstudio')) {
        this.app.browser.replaceElementBySelector(MainTemplate(), '.nftstudio');
      } else {
        this.app.browser.addElementToSelector(MainTemplate(), '.saito-container');
      }
      this.restoreDraft();
      this.renderEditor();
      this.syncFields();
      this.attachEvents();
      this.syncLayout();
      this.validate();
    }
  }, {
    key: "teardown",
    value: function teardown() {
      var _this$editor;
      clearTimeout(this.validationTimer);
      (_this$editor = this.editor) === null || _this$editor === void 0 || _this$editor.getWrapperElement().remove();
      this.editor = null;
    }
  }, {
    key: "restoreDraft",
    value: function restoreDraft() {
      try {
        var draft = loadDraft(window.localStorage);
        if (!draft) {
          this.setDraftStatus('No local draft loaded');
          return;
        }
        this.type = draft.type;
        this.title = draft.title;
        this.source = draft.source;
        this.setDraftStatus("Local draft restored from ".concat(this.formatTime(draft.savedAt)));
      } catch (err) {
        this.setDraftStatus(err.message, true);
      }
    }
  }, {
    key: "renderEditor",
    value: function renderEditor() {
      var _this = this;
      var parent = document.querySelector('.nftstudio .editor');
      this.editor = window.CodeMirror(parent, {
        value: this.source,
        mode: this.languageMode(),
        lineNumbers: true,
        indentUnit: 2,
        tabSize: 2
      });
      this.editor.on('change', function () {
        _this.source = _this.editor.getValue();
        _this.markDirty();
        clearTimeout(_this.validationTimer);
        _this.validationTimer = setTimeout(function () {
          var validation = _this.validate();
          if (_this.type === 'css' && _this.previewVisible) {
            if (validation.valid) {
              _this.renderCssPreview();
            } else {
              _this.clearPreview();
            }
          }
        }, 300);
      });
    }
  }, {
    key: "languageMode",
    value: function languageMode() {
      return this.type === 'css' ? 'css' : 'javascript';
    }
  }, {
    key: "syncFields",
    value: function syncFields() {
      document.querySelector('#nftstudio-title').value = this.title;
      document.querySelector('#nftstudio-type').value = this.type;
      this.updateFilename();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this2 = this;
      document.querySelector('#nftstudio-title').addEventListener('input', function (event) {
        _this2.title = event.target.value;
        _this2.updateFilename();
        _this2.markDirty();
      });
      document.querySelector('#nftstudio-type').addEventListener('change', function (event) {
        _this2.type = event.target.value;
        _this2.editor.setOption('mode', _this2.languageMode());
        _this2.updateFilename();
        _this2.previewVisible = false;
        _this2.clearPreview();
        _this2.syncLayout();
        _this2.markDirty();
        _this2.validate();
      });
      document.querySelector('[data-action="new"]').addEventListener('click', function () {
        return _this2.newDocument();
      });
      document.querySelector('[data-action="save"]').addEventListener('click', function () {
        return _this2.save();
      });
      document.querySelector('[data-action="import"]').addEventListener('click', function () {
        var input = document.querySelector('.nftstudio .file-input');
        input.value = '';
        input.click();
      });
      document.querySelector('[data-action="export"]').addEventListener('click', function () {
        return _this2.exportFile();
      });
      document.querySelector('[data-action="toggle-tools"]').addEventListener('click', function () {
        _this2.sidebarExpanded = !_this2.sidebarExpanded;
        _this2.syncLayout();
      });
      document.querySelector('[data-action="toggle-preview"]').addEventListener('click', function () {
        _this2.togglePreview();
      });
      document.querySelector('[data-action="validate"]').addEventListener('click', function () {
        return _this2.validate(true);
      });
      document.querySelector('[data-action="run"]').addEventListener('click', function () {
        return _this2.run();
      });
      document.querySelector('[data-action="publish"]').addEventListener('click', function () {
        return _this2.publish();
      });
      document.querySelector('.nftstudio .file-input').addEventListener('change', function (event) {
        var _event$target$files;
        return _this2.importFile((_event$target$files = event.target.files) === null || _event$target$files === void 0 ? void 0 : _event$target$files[0]);
      });
    }
  }, {
    key: "updateFilename",
    value: function updateFilename() {
      var base = this.safeFilename(this.title || 'untitled-nft');
      document.querySelector('.nftstudio .filename').textContent = "".concat(base, ".").concat(this.type);
    }
  }, {
    key: "syncLayout",
    value: function syncLayout() {
      var _this3 = this;
      var studio = document.querySelector('.nftstudio');
      var workspace = studio.querySelector('.workspace');
      var previewPanel = studio.querySelector('.preview-panel');
      var toolsToggle = studio.querySelector('[data-action="toggle-tools"]');
      var previewToggle = studio.querySelector('[data-action="toggle-preview"]');
      var runAction = studio.querySelector('[data-action="run"]');
      var isCss = this.type === 'css';
      if (!isCss) {
        this.previewVisible = false;
      }
      studio.classList.toggle('tools-collapsed', !this.sidebarExpanded);
      toolsToggle.setAttribute('aria-expanded', String(this.sidebarExpanded));
      toolsToggle.setAttribute('aria-label', this.sidebarExpanded ? 'Collapse tools' : 'Expand tools');
      toolsToggle.title = this.sidebarExpanded ? 'Collapse tools' : 'Expand tools';
      toolsToggle.querySelector('i').className = this.sidebarExpanded ? 'fa-solid fa-chevron-left' : 'fa-solid fa-chevron-right';
      workspace.classList.toggle('preview-visible', isCss && this.previewVisible);
      previewPanel.hidden = !isCss || !this.previewVisible;
      previewToggle.hidden = !isCss;
      previewToggle.setAttribute('aria-pressed', String(this.previewVisible));
      previewToggle.setAttribute('aria-label', this.previewVisible ? 'Hide side-by-side preview' : 'Show side-by-side preview');
      previewToggle.title = this.previewVisible ? 'Hide side-by-side preview' : 'Show side-by-side preview';
      runAction.title = isCss ? 'Preview CSS theme' : 'Run JavaScript NFT';
      runAction.setAttribute('aria-label', runAction.title);
      runAction.querySelector('i').className = isCss ? 'fa-solid fa-eye' : 'fa-solid fa-play';
      runAction.querySelector('span').textContent = isCss ? 'Preview' : 'Run';
      window.requestAnimationFrame(function () {
        var _this3$editor;
        return (_this3$editor = _this3.editor) === null || _this3$editor === void 0 ? void 0 : _this3$editor.refresh();
      });
    }
  }, {
    key: "markDirty",
    value: function markDirty() {
      this.isDirty = true;
      this.setDraftStatus('Unsaved changes');
    }
  }, {
    key: "newDocument",
    value: function newDocument() {
      if (this.isDirty && !window.confirm('Discard unsaved changes and create a new NFT?')) {
        return false;
      }
      this.title = '';
      this.type = 'js';
      this.source = '';
      this.previewVisible = false;
      this.replaceEditorSource('');
      this.editor.setOption('mode', this.languageMode());
      this.syncFields();
      this.clearPreview();
      this.syncLayout();
      this.validate();
      this.isDirty = false;
      this.setDraftStatus('New NFT');
      this.editor.focus();
      return true;
    }
  }, {
    key: "save",
    value: function save() {
      try {
        var draft = saveDraft(window.localStorage, {
          title: this.title,
          type: this.type,
          source: this.source
        });
        this.isDirty = false;
        this.setDraftStatus("Saved locally at ".concat(this.formatTime(draft.savedAt)));
      } catch (err) {
        this.setDraftStatus("Draft could not be saved: ".concat(err.message), true);
      }
    }
  }, {
    key: "importFile",
    value: function () {
      var _importFile = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(file) {
        var _file$name$split$pop;
        var extension, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              if (file) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              if (!(file.size > MAX_IMPORT_BYTES)) {
                _context.n = 2;
                break;
              }
              this.setDraftStatus('Import failed: file must be 2 MB or smaller', true);
              return _context.a(2);
            case 2:
              extension = (_file$name$split$pop = file.name.split('.').pop()) === null || _file$name$split$pop === void 0 ? void 0 : _file$name$split$pop.toLowerCase();
              if (['js', 'css'].includes(extension)) {
                _context.n = 3;
                break;
              }
              this.setDraftStatus('Import failed: choose a .js or .css file', true);
              return _context.a(2);
            case 3:
              _context.p = 3;
              this.type = extension;
              this.title = file.name.replace(/\.(js|css)$/i, '') || 'Untitled NFT';
              _context.n = 4;
              return file.text();
            case 4:
              this.source = _context.v;
              this.previewVisible = false;
              this.replaceEditorSource(this.source);
              this.editor.setOption('mode', this.languageMode());
              this.syncFields();
              this.clearPreview();
              this.syncLayout();
              this.markDirty();
              this.validate();
              _context.n = 6;
              break;
            case 5:
              _context.p = 5;
              _t = _context.v;
              this.setDraftStatus("Import failed: ".concat(_t.message), true);
            case 6:
              return _context.a(2);
          }
        }, _callee, this, [[3, 5]]);
      }));
      function importFile(_x) {
        return _importFile.apply(this, arguments);
      }
      return importFile;
    }()
  }, {
    key: "exportFile",
    value: function exportFile() {
      var blob = new Blob([this.source], {
        type: this.type === 'css' ? 'text/css;charset=utf-8' : 'text/javascript;charset=utf-8'
      });
      var url = URL.createObjectURL(blob);
      var link = document.createElement('a');
      link.href = url;
      link.download = "".concat(this.safeFilename(this.title || 'untitled-nft'), ".").concat(this.type);
      link.click();
      URL.revokeObjectURL(url);
    }
  }, {
    key: "replaceEditorSource",
    value: function replaceEditorSource(source) {
      this.editor.setValue(source);
    }
  }, {
    key: "validate",
    value: function validate() {
      var focusError = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var result = validateSource(this.type, this.source);
      var validation = document.querySelector('.nftstudio .validation');
      validation.dataset.state = result.valid ? 'valid' : 'invalid';
      validation.querySelector('.message').textContent = result.message;
      if (result.valid) {
        this.clearError();
      } else {
        var location = result.line ? "Line ".concat(result.line, ", column ").concat(result.column || 1, ": ") : '';
        this.showError("".concat(location).concat(result.message));
        if (focusError && result.line) {
          this.focusLine(result.line);
        }
      }
      return result;
    }
  }, {
    key: "focusLine",
    value: function focusLine(lineNumber) {
      var line = Math.min(Math.max(lineNumber - 1, 0), this.editor.lineCount() - 1);
      this.editor.setCursor({
        line: line,
        ch: 0
      });
      this.editor.scrollIntoView({
        line: line,
        ch: 0
      }, 100);
      this.editor.focus();
    }
  }, {
    key: "run",
    value: function () {
      var _run = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var validation, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              validation = this.validate(true);
              if (validation.valid) {
                _context2.n = 1;
                break;
              }
              this.clearPreview();
              return _context2.a(2);
            case 1:
              if (!(this.type === 'css')) {
                _context2.n = 2;
                break;
              }
              this.previewVisible = true;
              this.syncLayout();
              this.renderCssPreview();
              return _context2.a(2);
            case 2:
              this.previewVisible = false;
              this.clearPreview();
              this.syncLayout();
              _context2.p = 3;
              _context2.n = 4;
              return this.executeJavascript();
            case 4:
              _context2.n = 6;
              break;
            case 5:
              _context2.p = 5;
              _t2 = _context2.v;
              this.showError("Runtime error: ".concat((_t2 === null || _t2 === void 0 ? void 0 : _t2.message) || String(_t2)));
            case 6:
              return _context2.a(2);
          }
        }, _callee2, this, [[3, 5]]);
      }));
      function run() {
        return _run.apply(this, arguments);
      }
      return run;
    }()
  }, {
    key: "togglePreview",
    value: function togglePreview() {
      if (this.type !== 'css') {
        return;
      }
      if (this.previewVisible) {
        this.previewVisible = false;
        this.syncLayout();
        return;
      }
      this.run();
    }
  }, {
    key: "executeJavascript",
    value: function executeJavascript() {
      var _this$app;
      var execute = new Function("return (async () => {\n".concat(this.source, "\n})()"));
      return execute.call(((_this$app = this.app) === null || _this$app === void 0 ? void 0 : _this$app.wallet) || this);
    }
  }, {
    key: "renderCssPreview",
    value: function renderCssPreview() {
      document.querySelector('.nftstudio .preview').srcdoc = this.cssPreview();
    }
  }, {
    key: "publish",
    value: function publish() {
      var _this4 = this;
      var validation = this.validate(true);
      if (!validation.valid) {
        return;
      }
      var title = this.title.trim() || 'Untitled NFT';
      this.app.connection.emit('saito-nft-create-render-request', {
        type: this.type,
        content: this.source,
        title: title,
        description: "".concat(this.type === 'css' ? 'CSS' : 'JavaScript', " NFT created with NFT Studio"),
        locked: ['type', 'content'],
        callback: function callback() {
          var result = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          if (result.status === 'created') {
            _this4.setDraftStatus('NFT published');
          } else if (result.status === 'error') {
            _this4.setDraftStatus("Publish failed: ".concat(result.error || 'unknown error'), true);
          }
        }
      });
    }
  }, {
    key: "cssPreview",
    value: function cssPreview() {
      var stylesheet = "data:text/css;charset=utf-8,".concat(encodeURIComponent(this.source));
      return "<!doctype html>\n<html lang=\"en\" data-theme=\"dark\">\n<head>\n  <meta charset=\"utf-8\">\n  <meta name=\"viewport\" content=\"width=device-width, initial-scale=1\">\n  <link rel=\"stylesheet\" href=\"/saito/saito.css\">\n  <style>\n    body { margin: 0; padding: var(--saito-space-lg); }\n    .theme-preview { display: grid; gap: var(--saito-space-lg); max-width: 96rem; margin: 0 auto; }\n    .theme-preview-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(28rem, 1fr)); gap: var(--saito-space-md); }\n    .theme-preview-section { display: grid; gap: var(--saito-space-md); padding: var(--saito-space-lg); border: 1px solid var(--saito-border); border-radius: var(--saito-radius); background: var(--saito-card); }\n    .theme-preview-fields { display: grid; grid-template-columns: repeat(auto-fit, minmax(20rem, 1fr)); gap: var(--saito-space-md); }\n    .theme-preview-field { display: grid; gap: var(--saito-space-xs); }\n    .theme-preview-inline { display: flex; flex-wrap: wrap; align-items: center; gap: var(--saito-space-md); }\n    .theme-preview-table { width: 100%; border-collapse: collapse; }\n    .theme-preview-table :is(th, td) { padding: var(--saito-space-sm); border: 1px solid var(--saito-border); text-align: left; }\n    figure { margin: 0; }\n    svg { width: 100%; max-height: 16rem; color: var(--saito-primary); background: var(--saito-muted); }\n  </style>\n  <link rel=\"stylesheet\" href=\"".concat(stylesheet, "\">\n  <title>CSS theme preview</title>\n</head>\n<body>\n  <header class=\"theme-preview theme-preview-section\">\n    <span>Header</span>\n    <nav class=\"theme-preview-inline\" aria-label=\"Preview navigation\">\n      <a href=\"#typography\">Typography</a><a href=\"#forms\">Forms</a><a href=\"#content\">Content</a>\n    </nav>\n  </header>\n  <main class=\"theme-preview\">\n    <section id=\"typography\" class=\"theme-preview-section\">\n      <h1>Heading level one</h1><h2>Heading level two</h2><h3>Heading level three</h3>\n      <h4>Heading level four</h4><h5>Heading level five</h5><h6>Heading level six</h6>\n      <p>Body text with <a href=\"#\">a link</a>, <strong>strong text</strong>, <em>emphasis</em>, <mark>highlighting</mark>, <small>small text</small>, and <code>inline code</code>.</p>\n      <blockquote>Blockquote text demonstrates longer quoted content.</blockquote>\n      <pre><code>const theme = 'CSS NFT';</code></pre>\n      <hr>\n    </section>\n\n    <div class=\"theme-preview-grid\">\n      <article id=\"content\" class=\"theme-preview-section\">\n        <h2>Lists and disclosure</h2>\n        <ul><li>Unordered item</li><li>Another item</li></ul>\n        <ol><li>Ordered item</li><li>Another item</li></ol>\n        <dl><dt>Definition term</dt><dd>Definition description</dd></dl>\n        <details><summary>Expandable details</summary><p>Details content.</p></details>\n      </article>\n      <aside class=\"theme-preview-section\">\n        <h2>Media and status</h2>\n        <figure>\n          <svg viewBox=\"0 0 480 180\" role=\"img\" aria-label=\"Theme colour sample\"><rect width=\"480\" height=\"180\" fill=\"currentColor\"></rect><circle cx=\"240\" cy=\"90\" r=\"55\" fill=\"var(--saito-background)\"></circle></svg>\n          <figcaption>Figure caption</figcaption>\n        </figure>\n        <label>Progress <progress value=\"68\" max=\"100\">68%</progress></label>\n        <label>Meter <meter min=\"0\" max=\"100\" value=\"72\">72%</meter></label>\n      </aside>\n    </div>\n\n    <section id=\"forms\" class=\"theme-preview-section\">\n      <h2>Form elements</h2>\n      <form>\n        <fieldset class=\"theme-preview-section\">\n          <legend>Account details</legend>\n          <div class=\"theme-preview-fields\">\n            <label class=\"theme-preview-field\">Text<input class=\"saito-input\" type=\"text\" placeholder=\"Text input\"></label>\n            <label class=\"theme-preview-field\">Email<input class=\"saito-input\" type=\"email\" placeholder=\"name@example.com\"></label>\n            <label class=\"theme-preview-field\">Password<input class=\"saito-input\" type=\"password\" value=\"password\"></label>\n            <label class=\"theme-preview-field\">Search<input class=\"saito-input\" type=\"search\" placeholder=\"Search\"></label>\n            <label class=\"theme-preview-field\">Number<input class=\"saito-input\" type=\"number\" value=\"42\"></label>\n            <label class=\"theme-preview-field\">Date<input class=\"saito-input\" type=\"date\" value=\"2026-08-14\"></label>\n            <label class=\"theme-preview-field\">Select<select class=\"saito-form-select\"><option>First option</option><option>Second option</option></select></label>\n            <label class=\"theme-preview-field\">File<input type=\"file\"></label>\n          </div>\n          <label class=\"theme-preview-field\">Textarea<textarea class=\"saito-textarea\" rows=\"4\" placeholder=\"Longer text\"></textarea></label>\n          <div class=\"theme-preview-inline\">\n            <label><input class=\"saito-checkbox\" type=\"checkbox\" checked> Checked</label>\n            <label><input class=\"saito-checkbox\" type=\"checkbox\"> Checkbox</label>\n            <label><input class=\"saito-radio\" type=\"radio\" name=\"choice\" checked> Radio one</label>\n            <label><input class=\"saito-radio\" type=\"radio\" name=\"choice\"> Radio two</label>\n          </div>\n          <label class=\"theme-preview-field\">Range<input class=\"saito-range\" type=\"range\" min=\"0\" max=\"100\" value=\"60\"></label>\n          <div class=\"saito-button-row auto-size\">\n            <button class=\"saito-button-primary\" type=\"button\">Primary</button>\n            <button class=\"saito-button-secondary\" type=\"button\">Secondary</button>\n            <button type=\"button\">Default</button>\n            <button class=\"saito-button-primary\" type=\"button\" disabled>Disabled</button>\n          </div>\n        </fieldset>\n      </form>\n    </section>\n\n    <section class=\"theme-preview-section\">\n      <h2>Table</h2>\n      <table class=\"theme-preview-table\">\n        <caption>Example data</caption>\n        <thead><tr><th scope=\"col\">Name</th><th scope=\"col\">Status</th><th scope=\"col\">Value</th></tr></thead>\n        <tbody><tr><th scope=\"row\">Alpha</th><td>Active</td><td>100</td></tr><tr><th scope=\"row\">Beta</th><td>Pending</td><td>64</td></tr></tbody>\n      </table>\n    </section>\n  </main>\n  <footer class=\"theme-preview theme-preview-section\"><span>Footer content</span><a href=\"#\">Footer link</a></footer>\n</body>\n</html>");
    }
  }, {
    key: "clearPreview",
    value: function clearPreview() {
      document.querySelector('.nftstudio .preview').srcdoc = '<!doctype html><html><body></body></html>';
    }
  }, {
    key: "showError",
    value: function showError(message) {
      var error = document.querySelector('.nftstudio .error');
      error.textContent = message;
      error.classList.add('is-error');
      error.classList.remove('is-valid');
    }
  }, {
    key: "clearError",
    value: function clearError() {
      var error = document.querySelector('.nftstudio .error');
      error.textContent = 'OK';
      error.classList.remove('is-error');
      error.classList.add('is-valid');
    }
  }, {
    key: "setDraftStatus",
    value: function setDraftStatus(message) {
      var isError = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var status = document.querySelector('.nftstudio .draft-status');
      if (!status) {
        return;
      }
      status.textContent = message;
      status.classList.toggle('is-error', isError);
    }
  }, {
    key: "safeFilename",
    value: function safeFilename(value) {
      return value.trim().toLowerCase().replace(/[^a-z0-9_-]+/g, '-').replace(/^-+|-+$/g, '') || 'untitled-nft';
    }
  }, {
    key: "formatTime",
    value: function formatTime(value) {
      var date = new Date(value);
      return Number.isNaN(date.getTime()) ? 'an unknown time' : date.toLocaleTimeString();
    }
  }]);
}();
module.exports = NFTStudioMain;